import { lazy, Suspense } from "react";

import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";



const MenuSection = lazy(() => import("@/components/MenuSection"));

const Footer = lazy(() => import("@/components/Footer"));
const Manifesto = lazy(() => import("@/components/Manifesto"));
const Gallery = lazy(() => import("@/components/Gallery"));
const HoursLocation = lazy(() => import("@/components/HoursLocation"));

const VenueTourPage = lazy(() => import("@/components/VenueTourPage"));

const PageFallback = () => <div className="min-h-screen bg-obsidian" aria-hidden="true" />;

export default function App() {
  const path = window.location.pathname;
  const isAbout = /^\/about\/?$/.test(path);
  const isGallery = /^\/gallery\/?$/.test(path);
  const isFindUs = /^\/find-us\/?$/.test(path);
  const isVenueTour = /^\/venue-tour\/?$/.test(path);
  const isShisha = /^\/shisha-flavours\/?$/.test(path);
  const isMenus = /^\/menus\/?$/.test(path);


  const page = isAbout ? <main className="pt-[88px] md:pt-[72px]"><Manifesto /></main>
    : isGallery ? <main className="pt-[88px] md:pt-[72px]"><Gallery /></main>
    : isFindUs ? <main className="pt-[88px] md:pt-[72px]"><HoursLocation /></main>
    : isVenueTour ? <main className="pt-[88px] md:pt-[72px]"><VenueTourPage /></main>
    : isShisha ? <main className="pt-[88px] md:pt-[72px]"><MenuSection /></main>
    : isMenus ? <main className="pt-[88px] md:pt-[72px]"><MenuSection /></main>
    : <main><Hero /></main>;

  return (
    <div className="App grain bg-obsidian text-cream min-h-screen" data-testid="app-root">
      <Nav />
      <Suspense fallback={<PageFallback />}>{page}</Suspense>
      <Suspense fallback={null}><Footer hideMenuLinks compact /></Suspense>
    </div>
  );
}

